import React from 'react';
import './OrderTrackingTimeline.css';
import { FaBoxOpen, FaCheckCircle, FaBox, FaShippingFast, FaMotorcycle, FaGift, FaTimesCircle } from 'react-icons/fa';

function OrderTrackingTimeline({ status, trackingNumber, courierPartner }) {
  const stages = [
    { key: 'PENDING',          label: 'Order Placed',      icon: <FaBoxOpen /> },
    { key: 'CONFIRMED',        label: 'Confirmed',         icon: <FaCheckCircle /> },
    { key: 'PACKED',           label: 'Packed',            icon: <FaBox /> },
    { key: 'SHIPPED',          label: 'Shipped',           icon: <FaShippingFast /> },
    { key: 'OUT_FOR_DELIVERY', label: 'Out for Delivery',  icon: <FaMotorcycle /> },
    { key: 'DELIVERED',        label: 'Delivered',         icon: <FaGift /> },
  ];

  const statusIndex = stages.findIndex(s => s.key === status);
  const isCancelled = status === 'CANCELLED';

  return (
    <div className="od-card tracking-section">
      <div className="od-card-title">Order Tracking</div>

      {trackingNumber && (
        <div className="tracking-info">
          <p><strong>Tracking Number:</strong> {trackingNumber}</p>
          {courierPartner && <p><strong>Courier Partner:</strong> {courierPartner}</p>}
        </div>
      )}

      {isCancelled ? (
        <div className="cancelled-message">
          <FaTimesCircle className="cancelled-icon" />
          <p>This order has been cancelled</p>
        </div>
      ) : (
        <div className="timeline">
          {stages.map((stage, index) => (
            <div
              key={stage.key}
              className={`timeline-item ${index <= statusIndex ? 'completed' : ''} ${index === statusIndex ? 'active' : ''}`}
            >
              <div className="timeline-icon">{stage.icon}</div>
              <div className="timeline-content">
                <div className="timeline-label">{stage.label}</div>
              </div>
              {index < stages.length - 1 && <div className="timeline-line" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default OrderTrackingTimeline;
